import { render, staticRenderFns } from "./catSignature.vue?vue&type=template&id=57543961&"
import script from "./catSignature.vue?vue&type=script&lang=js&"
export * from "./catSignature.vue?vue&type=script&lang=js&"
import style0 from "./catSignature.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports